import { useCompaniesStore } from "~/store/companies/companies.store";
import { useFeedback } from "~/composables/feedback/useFeedback";

export default defineNuxtRouteMiddleware(async () => {
  /**
   * Named Middleware, it redirects if learning_paths feature is not enabled for the company
   */
  const companiesStore = useCompaniesStore();
  useFeedback();

  // Ensure companyInfos is loaded
  if (!companiesStore.companyInfos) {
    await companiesStore.fetchCompanyInfos();
  }

  if (!companiesStore.companyInfos?.learningPaths) {
    if (import.meta.client) {
      return abortNavigation();
    } else {
      return abortNavigation();
    }
  }
});
